
import React from 'react';
import { cn } from '@/lib/utils';
import { useDeviceOrientation } from '@/hooks/use-mobile';

interface MobileInstructionsProps {
  gameType: 'BlockStack' | 'Asteroids' | 'Breathing' | 'Matching' | 'Breakout';
  className?: string;
  customInstructions?: string;
}

const MobileInstructions: React.FC<MobileInstructionsProps> = ({ 
  gameType, 
  className,
  customInstructions 
}) => {
  const isLandscape = useDeviceOrientation();
  
  // Exclude BlockStack from landscape requirement entirely
  const needsLandscape = ['Asteroids', 'Breakout'].includes(gameType);
  
  // Game-specific instructions with clearer guidance
  const getGameInstructions = () => {
    if (customInstructions) return customInstructions;
    
    switch (gameType) {
      case 'BlockStack':
        return 'Tap to control: Left third → Move left | Right third → Move right | Top → Rotate | Bottom → Drop';
      case 'Asteroids':
        return 'Use touch controls below to navigate and shoot';
      case 'Breathing':
        return 'Follow the on-screen breathing pattern';
      case 'Matching':
        return 'Tap cards to match pairs';
      case 'Breakout':
        return 'Slide finger to move paddle';
      default:
        return 'Tap to interact with the game';
    }
  };

  return (
    <div 
      className={cn(
        "absolute bottom-0 left-0 right-0 bg-yellow-50 p-3 text-xs md:text-sm text-center shadow-lg z-10",
        className
      )}
      role="region"
      aria-label="Mobile instructions"
    >
      {needsLandscape && !isLandscape ? (
        <div className="font-bold text-orange-600">
          For best experience, rotate your device to landscape mode
        </div>
      ) : (
        <div>{getGameInstructions()}</div>
      )}
    </div>
  );
};

export default MobileInstructions;
